const uppercaseFirstLetter = (lower = "") => lower.charAt(0).toUpperCase() + lower.substring(1);

export default uppercaseFirstLetter;
